import { type ActivePodcastOrStation } from '@4tn/core-audio-player-shared';
import { streamTypes } from './consts';

export default class Media {
  streamSource!: ActivePodcastOrStation;

  slug!: string;

  mountPoint!: string;

  mountPointHD!: string;

  mp3Stream!: string;

  audioAac!: string;

  audioHls!: string;

  duration!: number | undefined;

  contentType!: string;

  contentId!: string;

  constructor(item: ActivePodcastOrStation) {
    if (item) {
      this.streamSource = item;
      this.slug = item.slug;
      this.duration = item.durationSeconds;

      this.contentType = item.contentTypeId;
      this.contentId = item.id;

      if (item.media && item.media.length > 0) {
        const itemMountPoint = item.media.filter(
          (media: { source: string }) => media.source === streamTypes.MOUNT_POINT
        )[0];
        const itemMountPointHD = item.media.filter(
          (media: { source: string }) => media.source === streamTypes.MOUNT_POINT_HD
        )[0];
        const audioAac = item.media.filter(
          (mediaItem: { source: string }) => mediaItem.source === streamTypes.AUDIO_ACC
        )[0];
        const audioHls = item.media.filter(
          (mediaItem: { source: string }) => mediaItem.source === streamTypes.AUDIO_HLS
        )[0];
        this.audioAac = audioAac?.uri;
        this.audioHls = audioHls?.uri;
        this.mountPoint = itemMountPoint ? itemMountPoint.uri : '';
        this.mountPointHD = itemMountPointHD ? itemMountPointHD.uri : '';
        const itemMp3Stream = item.media.filter(
          (media: { source: string }) => media.source === streamTypes.MP3_STREAM
        )[0];
        this.mp3Stream = itemMp3Stream ? itemMp3Stream.uri : '';
      }
    }

    // Make this class read-only
    Object.freeze(this);
  }

  public getStreamSource(): ActivePodcastOrStation {
    return this.streamSource;
  }
}
